import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    bg?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, bg, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    "peer flex border transition-all duration-500 bg-transparent focus:bg-white focus:placeholder:text-brand-dark focus:text-brand-dark [:focus+label]:text-primary border-stroke hover:border-fade w-full rounded-[40px] px-input-x py-3 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-white focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brand [.invalid_&]:ring-1 [.invalid_&]:ring-red-500 disabled:cursor-not-allowed disabled:opacity-50",
                    bg === "brand-light"
                        ? "border-brand-dark placeholder:text-brand-dark focus:bg-brand-dark focus:placeholder:text-white focus:text-white"
                        : "",
                    className
                )}
                ref={ref}
                {...props}
            />
        );
    }
);
Input.displayName = "Input";

export { Input };
